import Box from '@mui/material/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { tooltipClasses } from '@mui/material/Tooltip';
import { isValid, isValidWithoutData } from 'clients/Clients';
import { deleteItemWishlist, updateWishlist } from 'clients/WishlistClient';
import clsx from 'clsx';
import QuantityControlTable from 'components-v2/mocules/QuantityControlTable';
import LinkComp from 'components/atoms/LinkComp';
import ProductLimitMessage from 'components/mocules/ProductLimitMessage';
import SellerInfo from 'components/mocules/SellerInfo';
import { HTTP_STATUS } from 'constants/Enums/http';
import { SUBSTITUDE_ARROW_RIGHT_ICON, SUBSTITUDE_REPLACE_ICON } from 'constants/Images';
import { SUBSTITUTES } from 'constants/Paths';
import { SVGPrice } from 'constants/SVG';
import { useAuth } from 'context/Auth';
import useOnceInViewport from 'hooks/useOnceInViewport';
import useTrackingMonitorHighMargin from 'hooks/useTrackingMonitorHighMargin';
import useTrackingMonitor from 'hooks/useTrackingMonitor';
import useTrackingMonitorSubstituteProduct from 'hooks/useTrackingMonitorSubstituteProduct';
import { getResultPage, mapMainSkuStatus, mergeRefs } from 'utils/TrackingHelpers';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { getSKUErrorMessage } from 'services/convertNewAPIProduct';
import { DOMAIN_WEB_HOST } from 'sysconfig';
import calculateTimeLeftV2 from 'utils/calculateTimeLeftV2';
import gtag, { mapPathToCategory } from 'utils/gtag';
import { checkRule, conditionRender } from 'utils/helper';
import { ImageFallbackProductImage, ImageFallbackStatic } from 'utils/ImageFallback';
import { getMedicineTypeLabels } from 'utils/ProductLabelUtils';
import { getLinkProxyFile } from 'utils/ImageUtils';
import MonitorUtils, { MONITORING_COLLECTOR_TYPE } from 'utils/MonitorUtils';
import NotifyUtils from 'utils/NotifyUtils';
import { useStore } from 'zustand-lib/storeGlobal';
import useProductListStates from 'zustand-lib/useProductList';
import useSellers from 'zustand-lib/useSellers';
import BorderLinearProgress from '../BorderLinearProgress';
import CountdownNewV2 from '../CountdownNewV2';
import QuantityControlCart from '../QuantityControlCart';
import styles from './styles.module.css';
import { useConfigHangDiem } from 'hooks/useConfigHangDiem';
import ReplaceHangDiem from 'components-v2/atoms/ReplaceHangDiem';

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#A2A0A0',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#A2A0A0',
    color: '#fff',
    fontSize: 12,
    top: '0px',
  },
}));

function ProductTagNew({ data }) {
  return data?.preIconSvg ? (
    <LinkComp href={data?.link} className={styles.tagContainer}>
      <ImageFallbackStatic
        className={styles.image}
        height={30}
        width={60}
        objectFit="contain"
        fallbackSrc={getLinkProxyFile(data?.preIconSvg)}
        src={getLinkProxyFile(data?.preIconSvg)}
        alt="img"
      />
    </LinkComp>
  ) : null;
}

export default function ProductCardNewList({
  product,
  className,
  isTourGuide,
  showOriginalPrice = false,
  isCartPage = false,
  isSubstitude = false,
  skuSubstitute = '',
  mode,
}) {
  const router = useRouter();
  const { user } = useAuth();
  const curTime = new Date();

  // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
  const medicineTypeLabels = getMedicineTypeLabels(product);
  const [isWish, setIsWish] = useState(false);
  useEffect(() => {
    setIsWish(product.isWishList);
  }, [product.isWishList]);

  const [dealEndCampaign, setDealEndCampaign] = useState();
  const [memoizedTimeRemaining, setMemoizedTimeRemaining] = useState();
  const percentLine = Math.round((product.campaign?.totalSoldQuantity / product.campaign?.totalQuantity) * 100);
  const percentLineDeal = Math.round((product.deal?.totalCurrentQuantity / product.deal?.totalDealQuantity) * 100);
  const totalSold = product.campaign?.totalSoldQuantity || product.deal?.totalCurrentQuantity;
  const nearExpiration = product?.skuTags?.find((x) => x?.code === 'NEAR_EXPIRATION');
  const { firstSubstituteSkuRef } = useProductListStates();
  const { isHangDiem, iconHangDiem } = useConfigHangDiem({ vendorInfoSellerCode: product?.vendorInfo?.sellerCode });

  const trackingRef = useRef(null);
  useTrackingMonitor(trackingRef, product);

  const getSellerByCode = useSellers((state) => state.getSellerByCode);
  const sendEventCollector = useStore((state) => state.sendEventCollector);
  async function handleTrackingViewDetail() {
    const sellerInfo = await getSellerByCode({ code: product?.sellerCode, tags: product.tags });
    gtag.viewItemInPage({ product: { ...product, sellerInfo }, path: router.pathname });
    sendEventCollector(MonitorUtils.sendSKUEvent(MONITORING_COLLECTOR_TYPE.SKU_DETAIL_VIEW, { ...product, sellerInfo }, router.pathname, true));
    handleHighMarginClickDetail();
  }

  const { trackingMonitorSubstituteAddToCart, trackingMonitorSubstituteClickDetail, trackingMonitorSubstituteMainSKUImpression } =
    useTrackingMonitorSubstituteProduct();
  const { trackingHighMarginImpression, trackingHighMarginClickDetail, trackingHighMarginAddToCart } = useTrackingMonitorHighMargin();
  const { sellerIdMainSKU, productIdMainSKU, mainSKU, mainType } = router.query || {};
  const linkHref = isSubstitude
    ? `${DOMAIN_WEB_HOST}/product/${product.slug || ''}?isSKUReplace=true&sellerIdMainSKU=${sellerIdMainSKU}&productIdMainSKU=${productIdMainSKU}&mainSKU=${mainSKU}&mainType=${mainType}`
    : `${DOMAIN_WEB_HOST}/product/${product.slug || ''}`;

  const appSetting = useStore((state) => state.appSetting);
  const errorMessageProduct = getSKUErrorMessage(product, appSetting);

  const revertDisplayFormat = (price) => {
    if (price?.length > 11) {
      return price?.substring(0, 8) + '..';
    }
    return price;
  };

  useEffect(() => {
    const convertEndDay =
      product.productType === 'MEGA_DAY'
        ? product.campaign?.campaign?.endTime
        : product.campaign?.flashSaleTime?.find((item) => new Date(item.startTime) < curTime && new Date(item.endTime) > curTime)?.endTime;
    setDealEndCampaign(convertEndDay);
    setMemoizedTimeRemaining(calculateTimeLeftV2(convertEndDay || product.deal?.endTime));
  }, []);

  const handleDeleteProductWishlist = async (product) => {
    const res = await deleteItemWishlist(product?.sku);
    if (isValidWithoutData(res)) {
      setIsWish(() => false);
      return NotifyUtils.success(`Đã xóa ${product?.name} khỏi danh sách quan tâm`);
    }
    return NotifyUtils.error(`Xóa sản phẩm ${product?.name} khỏi danh sách quan tâm thất bại`);
  };

  const handleUpdateWishlist = async (product) => {
    const res = await updateWishlist(product?.sku);
    if (isValid(res) || res?.status === HTTP_STATUS.Existed) {
      setIsWish(() => true);
      return NotifyUtils.success(`Đã thêm ${product?.name} vào danh sách quan tâm`);
    }
    return NotifyUtils.error(`Thêm ${product?.name} vào danh sách sản phẩm quan tâm thất bại`);
  };

  const handleClickWhistList = async () => {
    if (isWish) {
      handleDeleteProductWishlist(product);
    } else {
      handleUpdateWishlist(product);
    }
  };

  const hasError = errorMessageProduct || !product.salePrice || product.status === 'STOP_SELLING' || product.salePrice === 0;

  const conditionRenderTag = (listTag) => {
    if (listTag && listTag?.length > 3) {
      return listTag?.filter((x) => x?.code !== 'NEAR_EXPIRATION').slice(0, 3);
    }
    return listTag?.filter((x) => x?.code !== 'NEAR_EXPIRATION');
  };

  const renderQuantityInput = () => {
    const handleClickSubstituteAddToCart = () => {
      if (isSubstitude) {
        gtag.substituteClickAddToCart({
          screen: mapPathToCategory(router.pathname),
          customerId: user?.customerID,
          sku: product.sku,
          productId: product.productId,
          sellerId: product.sellerInfo.sellerID,
          resultPage: getResultPage(router),
          mainSkuStatus: mapMainSkuStatus(mainType),
        });
        trackingMonitorSubstituteAddToCart({
          sku: product.sku,
          sellerId: product.sellerInfo.sellerID,
          sellerCode: product.seller.code,
          productId: product.productId,
          type: product?.errorCode || 'Instock',
          pathname: router.pathname,
          resultPage: getResultPage(router),
          sellerIdMainSKU: sellerIdMainSKU || '',
          productIdMainSKU: productIdMainSKU || '',
          mainSKU: mainSKU || '',
          mainType: mainType || '',
        });
      }
    };

    const isMaxBuy = product?.consumedMaxQuantity?.maxQuantityConsumed === 0 && product?.consumedMaxQuantity?.maxQuantityType === 'PER_DAY';
    if (isMaxBuy) {
      return <></>;
    }

    if (isCartPage) {
      return <QuantityControlCart className={styles.quantityControlContainer} product={product} newCard mode={mode} />;
    }

    return (
      <QuantityControlTable
        className={styles.quantityControlContainer}
        product={product}
        newCard
        onChange={() => {
          handleClickSubstituteAddToCart();
          handleHighMarginAddToCart();
        }}
        onAdd={() => {
          handleClickSubstituteAddToCart();
          handleHighMarginAddToCart();
        }}
      />
    );
  };

  const conditionRenderCountdown = () => {
    if (showOriginalPrice) {
      return true;
    }
    // make sure time countdown is 96 hours
    // days < 4 => 72h + 24h => maximum 96h
    if (memoizedTimeRemaining?.days < 4) {
      return false;
    }

    return true;
  };

  const handleClickSubstitute = () => {
    // TODO: Click to substitute product
    if (isSubstitude) {
      gtag.substituteClickDetail({
        customerId: user?.customerID,
        screen: mapPathToCategory(router.pathname),
        sku: product.sku,
        productId: product.productId,
        sellerCode: product.seller.code,
        sellerId: product.sellerInfo.sellerID,
        resultPage: getResultPage(router),
        mainSkuStatus: mapMainSkuStatus(mainType),
      });
      trackingMonitorSubstituteClickDetail({
        sku: product.sku,
        sellerCode: product.seller.code,
        sellerId: product.sellerInfo.sellerID,
        productId: product.productId,
        type: product?.errorCode || 'Instock',
        pathname: router.pathname,
        resultPage: getResultPage(router),
        sellerIdMainSKU: sellerIdMainSKU || '',
        productIdMainSKU: productIdMainSKU || '',
        mainSKU: mainSKU || '',
        mainType: mainType || '',
      });
    }
  };

  // Impression 50% viewport (spec MKT), thay cho onMouseEnter trước đây:
  // - card SP thay thế (isSubstitude): event "Search result having substitute product impression"
  // - card SKU gốc có hàng thay thế (skuReplace): event "Oos/suspended SKU impression"
  const oosImpressionRef = useOnceInViewport(() => {
    // Event "Search result having high margin product impression" (spec MKT)
    if (product?.isHighProfit) {
      gtag.highMarginImpression({
        customerId: user?.customerID,
        screen: mapPathToCategory(router.pathname),
        resultPage: getResultPage(router),
        sku: product.sku,
        sellerId: product.sellerInfo?.sellerID,
        productId: product.productId,
      });
      trackingHighMarginImpression({
        sku: product.sku,
        sellerId: product.sellerInfo?.sellerID?.toString() || '',
        productId: product.productId?.toString() || '',
        pathname: router.pathname,
        resultPage: getResultPage(router),
      });
    }

    if (isSubstitude) {
      gtag.substituteSearchResult({
        screen: mapPathToCategory(router.pathname),
        customerId: user?.customerID,
        resultPage: getResultPage(router),
        mainSkuStatus: mapMainSkuStatus(mainType),
        sku: product.sku,
        sellerId: product.sellerInfo?.sellerID,
        productId: product.productId,
      });
      trackingMonitorSubstituteMainSKUImpression({
        sku: product.sku,
        sellerCode: product.seller?.code,
        sellerId: product.sellerInfo?.sellerID,
        productId: product.productId,
        type: product?.errorCode || 'Instock',
        pathname: router.pathname,
        resultPage: getResultPage(router),
        sellerIdMainSKU: sellerIdMainSKU || '',
        productIdMainSKU: productIdMainSKU || '',
        mainSKU: mainSKU || '',
        mainType: mainType || '',
      });
      return;
    }

    if (!(product.skuReplace?.length > 0)) return;

    gtag.substituteHoverProductCard({
      customerId: user?.customerID,
      sku: product.sku,
      productId: product.productId,
      sellerCode: product.seller?.code,
      resultPage: getResultPage(router),
    });
    trackingMonitorSubstituteMainSKUImpression({
      sku: product.sku,
      sellerCode: product.seller?.code,
      productId: product.productId,
      type: product?.errorCode || 'Instock',
      pathname: router.pathname,
      resultPage: getResultPage(router),
      sellerIdMainSKU: sellerIdMainSKU || '',
      productIdMainSKU: productIdMainSKU || '',
      mainSKU: mainSKU || '',
      mainType: mainType || '',
    });
  }, 0.5, isSubstitude || !!product?.isHighProfit || product?.skuReplace?.length > 0);

  const handleHighMarginClickDetail = () => {
    if (!product?.isHighProfit) return;
    gtag.highMarginClickDetail({
      customerId: user?.customerID,
      screen: mapPathToCategory(router.pathname),
      resultPage: getResultPage(router),
      sku: product.sku,
      sellerId: product.sellerInfo?.sellerID,
      productId: product.productId,
    });
    trackingHighMarginClickDetail({
      sku: product.sku,
      sellerId: product.sellerInfo?.sellerID?.toString() || '',
      productId: product.productId?.toString() || '',
      pathname: router.pathname,
      resultPage: getResultPage(router),
    });
  };

  const handleHighMarginAddToCart = () => {
    if (!product?.isHighProfit) return;
    gtag.highMarginAddToCart({
      customerId: user?.customerID,
      screen: mapPathToCategory(router.pathname),
      resultPage: getResultPage(router),
      sku: product.sku,
      sellerId: product.sellerInfo?.sellerID,
      productId: product.productId,
    });
    trackingHighMarginAddToCart({
      sku: product.sku,
      sellerId: product.sellerInfo?.sellerID?.toString() || '',
      productId: product.productId?.toString() || '',
      pathname: router.pathname,
      resultPage: getResultPage(router),
    });
  };

  return (
    <div
      className={clsx(styles.container, className && className, 'card-new-list')}
      id={product.sku}
      onClick={handleClickSubstitute}
      ref={mergeRefs(skuSubstitute === product.sku ? firstSubstituteSkuRef : trackingRef, oosImpressionRef)}
    >
      {product.discountPercent && !isSubstitude ? <div className={styles.promo}> -{product.discountPercent}%</div> : null}

      {product.isContractPrice && !isSubstitude ? <div className={styles.contract}> Giá Hợp Đồng</div> : null}

      {nearExpiration && !isSubstitude ? (
        <div style={{ color: nearExpiration?.textColor, backgroundColor: nearExpiration?.backgroundColor }} className={styles.nearExpiration}>
          {nearExpiration?.name}
        </div>
      ) : null}

      {!!isSubstitude && (
        <Box className={styles.replaceSkuTag}>
          <Image src={SUBSTITUDE_REPLACE_ICON} width={16} height={16} alt="replace icon" /> Sản phẩm thay thế
        </Box>
      )}

      <div className={styles.tooltipRight} onClick={handleClickWhistList} role="button">
        <LightTooltip title={isWish ? 'Bỏ đánh dấu sản phẩm' : 'Đánh dấu sản phẩm quan tâm'} arrow placement="top">
          <div className={styles?.customButton}>
            {isWish ? (
              <FavoriteIcon style={{ fontSize: 24, color: 'var(--primary-color)' }} />
            ) : (
              <FavoriteBorderIcon className={styles.icon} style={{ fontSize: 24, color: '#00000033' }} />
            )}
          </div>
        </LightTooltip>
      </div>

      <div className={styles.topContainer}>
        <LinkComp href={linkHref} className={styles.stylesImage}>
          <ImageFallbackProductImage
            className={styles.image}
            size="medium"
            height={160}
            width={160}
            objectFit="contain"
            src={product.defaultImage}
            alt="img"
            onClick={handleTrackingViewDetail}
          />
        </LinkComp>

        <div className={styles.listTag}>
          {conditionRenderTag(product?.skuTags)?.map((x) => (
            <ProductTagNew key={x?.code} data={x} />
          ))}
        </div>

        {isTourGuide ? (
          <div id="list__tag_guide" className={clsx(styles.listTagGuide, product.productType === 'MEGA_DAY' && styles.listTagGuideMega)}>
            <div className={styles.listTag}>
              {conditionRenderTag(product?.skuTags)?.map((x) => (
                <ProductTagNew key={x?.code} data={x} />
              ))}
            </div>
          </div>
        ) : (
          <div className={styles.listTag}>
            {conditionRenderTag(product?.skuTags)?.map((x) => (
              <ProductTagNew key={x?.code} data={x} />
            ))}
          </div>
        )}
      </div>

      <div className={styles.underContainer}>
        <div className={styles.priceContainer}>
          <div className={styles.price}>
            <SVGPrice displayPriceFormated={product.displayPriceFormated || 0} size="mdn" />
          </div>
          {product.discountPercent > 0 && (
            <>
              {conditionRenderCountdown() ? (
                <div className={styles.pricePromo}>
                  <SVGPrice displayPriceFormated={revertDisplayFormat(product.salePriceFormated) ?? 0} size="smn" fillPath="#333333" line />
                </div>
              ) : (
                <div className={clsx(styles.dateExpired)}>
                  <CountdownNewV2 targetDate={dealEndCampaign || product.deal?.endTime} hasMoreText />
                </div>
              )}
              {/* BV-1669: card SPTT không có ribbon `.promo` ở góc (chỗ đó là tag
                  "Sản phẩm thay thế") nên hiện % giảm ngay cạnh giá. */}
              {isSubstitude && <Chip className={styles.cardChip} label={`-${product.discountPercent}%`} size="small" />}
            </>
          )}
        </div>

        <div className={styles.titleContainer}>
          <Link href={linkHref}>
            <a className={styles.titleWrapper} onClick={handleTrackingViewDetail}>
              {product.skuLabels?.map((label) => (
                <div key={label?.code} className={styles.labelImage}>
                  <div key={label?.code} className={clsx(!isHangDiem ? styles.labelImage : styles.hangDiemLabelImage)}>
                    {isHangDiem && label.code === '2ABC' ? (
                      <ReplaceHangDiem iconHangDiem={iconHangDiem} type="old_product" />
                    ) : (
                      <ImageFallbackStatic
                        width={label.code === '2ABC' ? 63 : 25}
                        height={18}
                        objectFit="contain"
                        fallbackSrc={getLinkProxyFile(label?.preIconSvg)}
                        src={getLinkProxyFile(label?.preIconSvg)}
                        alt="img"
                      />
                    )}
                  </div>
                </div>
              ))}
              <span>{product.name}</span>
            </a>
          </Link>
          <div className={styles.countPerItem}>{product.volume || ''}</div>
        </div>

        {medicineTypeLabels.length > 0 && (
          <div className={styles.medicineType}>
            {medicineTypeLabels.map((info) => (
              <ImageFallbackStatic
                key={info.variant}
                src={info.icon.src}
                width={info.icon.width}
                height={info.icon.height}
                objectFit="contain"
                alt={info.label}
              />
            ))}
          </div>
        )}

        <div className={styles?.sellerContainer}>
          <SellerInfo sellerInfo={product.sellerInfo} tags={product?.tags} isProductCard product={product} />
        </div>

        <div className={styles.progressContainer}>
          <div className={styles.progressBuy}>
            {product.productType !== 'NORMAL' ? (
              <>
                <BorderLinearProgress
                  value={percentLine || percentLineDeal || 5}
                  variant="determinate"
                  width="100%"
                  height="14px !important"
                  bgcolor="#F9BDC0"
                  bgliner="#EA202B"
                  linerradius={0}
                />
                <div className={styles.buyCount}>
                  {percentLineDeal ? (
                    <>{conditionRender(percentLineDeal) ? checkRule(percentLineDeal) : `Đã bán ${totalSold}`}</>
                  ) : (
                    <>{conditionRender(percentLine) ? checkRule(percentLine) : `Đã bán ${totalSold}`}</>
                  )}
                </div>
              </>
            ) : null}
          </div>
          {!hasError && (
            <ProductLimitMessage
              consumedMaxQuantity={product.consumedMaxQuantity}
              unit={product.unit}
              page="products"
              className={styles.limitMessage}
              isNewCard
            />
          )}
        </div>

        <div className={styles.controlQuantity}>
          {product.skuReplace?.length > 0 ? (
            <ReplaceProductBlock
              slug={product.skuReplace?.[0]?.sku?.slug}
              hasErrorMessage={hasError}
              errorMessage={errorMessageProduct || product.errorMessage || 'Đang cập nhật giá'}
              skuReplace={product.skuReplace}
            />
          ) : (
            <>{hasError && <div className={styles.error}>{errorMessageProduct || product.errorMessage || 'Đang cập nhật giá'}</div>}</>
          )}
        </div>
      </div>

      {!hasError && renderQuantityInput()}
    </div>
  );
}

const ReplaceProductBlock = ({ hasErrorMessage = false, errorMessage = '', skuReplace = [] }) => {
  const router = useRouter();
  const [isOnEffect, toggleEffect] = useState(false);
  const handleClick = () => {
    let listSkuReplaceBlock;
    if (router.pathname === SUBSTITUTES) {
      listSkuReplaceBlock = skuReplace.map((item) => item?.sku?.sku);
    } else {
      listSkuReplaceBlock = skuReplace.map((item) => item?.sku);
    }
    const queryAllSkuReplaceBlock = listSkuReplaceBlock?.map((item) => document.getElementById(item));
    if (queryAllSkuReplaceBlock?.length > 0) {
      queryAllSkuReplaceBlock?.forEach((item) => {
        item?.classList.add(styles.glowOnEffect);
        toggleEffect(true);

        setTimeout(() => {
          item?.classList.remove(styles.glowOnEffect);
          toggleEffect(false);
        }, 3000);
      });
    }
  };

  if (!hasErrorMessage) return null;

  return (
    <Box display="flex" justifyContent="center" flexDirection="column" padding="0 8px" alignItems="center">
      <span className={styles.skuReplaceErrorMessage}>{errorMessage}</span>
      <Button
        className={styles.buttonRedirectReplaceSku}
        onClick={() => {
          if (!isOnEffect) {
            handleClick();
          }
        }}
      >
        Xem sản phẩm thay thế
        <Image src={SUBSTITUDE_ARROW_RIGHT_ICON} width={16} height={16} alt="arrow right icon" />
      </Button>
    </Box>
  );
};
